// The customizer's keyboard, out of CustomizerScreen (backfill PR 31): Ctrl/Cmd+Z undoes,
// Ctrl/Cmd+Shift+Z and Ctrl/Cmd+Y redo, and Escape unselects the keycaps unless a modal is
// open, as the keyboard equivalent of a click next to them.
import { useEffect } from 'react';

export function useUndoRedoShortcuts(undoChange, redoChange) {
  useEffect(() => {
    const handleKeyDown = (event) => {
      if ((event.ctrlKey || event.metaKey) && event.key === 'z') {
        event.preventDefault(); // prevents the browser's default undo action
        if (event.shiftKey) {
          redoChange(); // if the user presses 'CTRL+SHIFT+Z' or 'META+SHIFT+Z', a redoChange will be triggered
        } else {
          undoChange(); // if the user presses 'CTRL+Z' or 'META+Z', an undoChange will be triggered
        }
      } else if (
        (event.ctrlKey || event.metaKey) &&
        (event.key === 'y' || (event.shiftKey && event.key === 'Z'))
      ) {
        event.preventDefault(); // prevents the browser's default redo action
        redoChange(); // if the user presses 'CTRL+Y', 'META+Y', 'CTRL+SHIFT+Z' or 'META+SHIFT+Z', a redoChange will be triggered
      }
    };

    document.addEventListener('keydown', handleKeyDown); // adds a listener for keydown event

    return () => {
      document.removeEventListener('keydown', handleKeyDown); // a cleanup function to remove the event listener
    };
  }, [undoChange, redoChange]); // this useEffect hook listens for keydown events that trigger a redoChange or undoChange on the unsers design changes
} // the undo and redo shortcuts, on the document while the customizer is open

export function useEscapeUnselect(design, updateDesign) {
  useEffect(() => {
    const unselectOnEscape = (event) => {
      if (event.key !== 'Escape') return;

      if (
        !design.settings.selectedKeycaps?.length &&
        !design.settings.isoEnterSelected
      )
        return; // nothing is selected, so there is nothing to unselect

      if (document.querySelector('.modal.show')) return; // let Escape close an open modal instead of clearing the selection behind it

      updateDesign({
        'settings.selectedKeycaps': [],
        'settings.isoEnterSelected': false,
        'keycapColorEditor.selectedColorEntry': null,
      });
    };

    document.addEventListener('keydown', unselectOnEscape);

    return () => {
      document.removeEventListener('keydown', unselectOnEscape);
    };
  }); // Escape unselects the keycaps, the keyboard equivalent of clicking an empty spot next to them (no dependency array: updateDesign is recreated on every render)
} // the Escape key's unselect, on the document while the customizer is open
